import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  isLoading: false,
};

const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    showLoader: (state) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoader: (state) => {
      return {
        ...state,
        isLoading: false,
      };
    },
  },
});

export const { showLoader, hideLoader } = loaderSlice.actions;
export default loaderSlice.reducer;
